import { SideMenuGroup } from '@v2/shared/Layouts/SideMenu';

/**
 * MagZoom's institutional pages.
 *
 * Hardcoded for the same reason the other brands' lists are: these are fixed pages, none
 * of them editable anywhere, and the same ones are already spelled out in the footer.
 *
 * DiscountMags' grouping, minus the group MagZoom has no pages for: DiscountMags opens
 * with "Shop with Confidence" — guarantee, DiscountLock, reviews, payment methods — and
 * MagZoom publishes none of those. What is left is Policies then Help, in DiscountMags'
 * order within each, which is also how MagZoom's own footer already splits these same
 * pages into "Legal" and "About".
 *
 * "Refund Policy" is listed even though MagZoom's footer does not offer it. The page is
 * real — `/refund` — and this brand's own terms of use link to it, so a shopper reading the
 * agreement they accepted has somewhere to go back to. It leads the Policies group because
 * that is where DiscountMags puts it.
 *
 * MagSpot ends up with the same seven entries, which is the two vhosts rewriting the same
 * paths rather than a list the brands share: each entry is a page this brand publishes,
 * and either one adding or renaming a page splits them again.
 *
 * The hrefs are now the same slugs as every other brand's, out of PageRegistry: the server
 * marks an entry current by comparing its path against `activePath`, which that registry
 * supplies, so a path spelled differently here is not a broken link — the old urls all 301 —
 * but it is an entry that can never be highlighted. `/help` is this brand's FAQ page; on
 * DiscountMags the same slug is a redirect off-site.
 *
 * Paths are relative; every one of them goes through buildUrl before it is rendered.
 */
export const INSTITUTIONAL_MENU: SideMenuGroup[] = [
  {
    title: 'Policies',
    items: [
      { label: 'Refund Policy', href: '/refund-policy' },
      { label: 'Privacy Policy', href: '/privacy' },
      { label: 'Terms of Use', href: '/terms' },
      { label: 'Accessibility', href: '/accessibility' },
    ],
  },
  {
    title: 'Help',
    items: [
      { label: 'FAQs', href: '/help' },
      { label: 'Contact Us', href: '/contact' },
      { label: 'About Us', href: '/about-us' },
    ],
  },
];
